import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  ...zhLocale,
  "pageTitle": {
    "index": "韩国签证申请中心--官方授权指定机构",
    "login": "账号登录",
    "retrieve": "找回密码",
    "register": "注册账号",
    "center": "个人中心",
    "userMsg": "消息中心",
    "news": "新闻中心",
    "serviceCenter": "客户服务中心",
    "clientCenter": "客户中心",
    "tour": "旅游信息",
    "tourList": "旅游信息",
    "orderList": "我的订单",
    "orderDetail": "订单详情",
    "applyTodoList": "待办申请列表",
    "changePhone": "更换手机",
    "address": "常用地址",
    "addressDetail": "地址详情",
    "setting": "设置",
    "aboutUs": "关于我们",
    "contactUs": "联系我们",
    "businessCooperation": "商务合作",
    "FAQ": "常见问题",
    "feedback": "意见反馈",
    "changePsd": "修改密码",
    "choiceVisaType": "签证申请",
    "saveBasicInfo": "签证申请信息",
    "saveApplyInfo": "签证申请信息",
    "visaInformation": "签证申请信息",
    "confirmApply": "签证申请信息",
    "applicantInfo": "申请人信息",
    "sendMaterials": "申请寄送材料",
    "sendDataInfo": "签证申请",
    "receiveDataInfo": "签证申请",
    "visaData": "签证所需资料",
    "confirmPay": "确认支付",
    "msgList": "消息中心",
    "visaCenter": "签证中心",
    "siteMap": "网站地图",
    "paySuccess": "订单支付",
    "law": "韩国基本法秩序",
    "agreement": "用户协议",
    "invoiceList": "发票抬头",
    "invoiceDetail": "添加发票抬头",
    "generateForm": "生成申请表",
    "generateFormSuccess": "生成申请表成功",
    changeEmail: "更换邮箱",
    applyInvoice: "申请发票",
    expressInfo: "物流信息",
    reserve: "预约时间",
    confirmApplicant: "信息确认",
    visaInQuery: "办理进度查询",
    TravelAgencyIdentity: "旅行社身份申请",
    queryResults: "查询结果",
  },
  header: {
    title: "欢迎访问韩国签证申请中心",
    login: {
      unLogin: {
        login: "登录",
        register: "注册",
      },
      logined: {
        order: "我的订单",
        todoList: "待办申请",
        message: "消息中心",
        address: "常用地址",
        changePsd: "修改密码",
        changePhone: "更换手机",
        changeEmail: "更换邮箱",
        logout: "退出登录",
      },
    },
    todoList: "待办申请",
    lang: "简体中文",
    nav: {
      index: "首页",
      visa: "签证申请",
      query: "申请查询",
      news: "新闻中心",
      client: "客户中心",
      tour: "旅游信息",
      aboutUs: "关于我们",
      law: "韩国基本法秩序",
      reservation: "线下预约",
    },
    menu: {
      guide: "签证指南",
      procedures: "办签流程",
      application: "签证申请",
      query: "发放查询",
      'offline booking': "线下预约"
    },
    visas: "出签人数",
    number: "位",
  },

  footer: {
    'reminder': '温馨提示：本网站（PC端，小程序，公众号）所使用目的地图片和介绍信息均由韩国旅游发展局提供',
    'About us': "关于我们",
    'Contact us': "联系我们",
    'feedback': "意见反馈",
    'business cooperation': "商务合作",
    'App download': "App 下载",
    'Site map': "网站地图",
    'User agreement': "用户协议",
  },
  /*---------------------------   客户中心     --------------------------*/
  serviceCenter: {
    title: "客户中心",
    home: "首页",
    'Customer center': "客户中心",
    'Customer service center': "客户服务中心"
  },
  /*---------------------------   新闻中心     --------------------------*/
  news: {
    HOME: "首页",
    NEWS: "新闻中心",
    LAW: "韩国基本法秩序",
  },
  /*---------------------------   旅游信息     --------------------------*/
  tour: {
    'Tourist information': "旅行信息",
    'HOME': "首页",
    'hot spots': "热门推荐",
    'Theme travel': "主题旅行"
  },
  /*---------------------------   登录页     --------------------------*/
  "login": {
    Copyright: "韩国签证申请中心",
    "title": {
      "s1": "没有账号？",
      "s2": "请注册"
    },
    "welcome": "欢迎登录",
    loginType: {
      type1: "用户登录",
      type2: "认证旅行社登录"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "请输入手机号码"
      },
      "password": {
        "name": "密码",
        "placeholder": "请输入您的密码"
      },
      account: {
        "name": "账号",
        "placeholder": "请输入旅行社账号"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "请输入图形验证码"
      }
    },
    "rulesErr": {
      'mobile is required': "请填写手机号",
      "mobile is not correct": "手机号不正确",
      "account is required": "请输入旅行社账号",
      "password is required": "请填写密码",
      "password is not correct": "请填写6至20位密码",
      "authCode is required": "请填写验证码"
    },
    "loginMore": {
      "Remember account": "记住账号",
      "retrieve": "忘记密码？",
      "register": "注册账号"
    },
    "loginBtn": "登 录",
    "logging": "正在登陆"
  },
  "retrieve": {
    "title": {
      "s1": "没有账号？",
      "s2": "请注册"
    },
    retrieve: "找回密码",
    retrieveType: {
      type1: "手机号找回密码",
      type2: "邮箱找回密码"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "请输入注册手机号"
      },
      "email": {
        "name": "邮箱",
        "placeholder": "请输入注册时填写的电子邮箱"
      },
      "picCode": {
        "name": "图形验证",
        "placeholder": "请输入验证码"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "请输入验证码"
      },
      "resetPsd": {
        "name": "重置密码",
        "placeholder": "请输入重置密码：6位至20位"
      },
      "confirmPsd": {
        "name": "确认密码",
        "placeholder": "再次确认重置密码"
      }
    },
    "rulesErr": {
      'mobile is required': "请填写手机号",
      "mobile is not correct": "手机号不正确",
      "picCode is required": "请填写图形验证码",
      "authCode is required": "请填写验证码",
      "resetPsd is required": "请填写重置密码",
      "confirmPsd is required": "请再次填写重置密码",
      "psdNumber is not correct": "请填写6至20位密码",
      "inconsistent password": "两次输入的密码不一致",
      "email is required": "请填写注册邮箱",
      "email is not correct": "邮箱不正确"
    },
    "authBtn": "获取验证码",
    "resetPsdBtn": "重置密码"
  },

  /*---------------------------   注册页     --------------------------*/
  "register": {
    'Welcome to register': "欢迎注册",
    "title": {
      "s1": "已有账号？",
      "s2": "请登录"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "请输入11位手机号码"
      },
      "picCode": {
        "name": "图形验证",
        "placeholder": "请输入图形验证码"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "请输入验证码"
      },
      "email": {
        "name": "邮箱",
        "placeholder": "请输入您的电子邮箱"
      },
      "password": {
        "name": "密码",
        "placeholder": "请输入密码（6-20位数字或英文字母）"
      },
      "confirmPsd": {
        "name": "重复密码",
        "placeholder": "请再次输入您刚设置的密码"
      }
    },
    "rulesErr": {
      'mobile is required': "请填写手机号",
      "mobile is not correct": "手机号不正确",
      "picCode is required": "请填写图形验证码",
      "authCode is required": "请填写验证码",
      "password is required": "请填写密码",
      "confirmPsd is required": "请再次填写密码",
      "psdNumber is not correct": "请填写6至20位密码",
      "inconsistent password": "两次输入的密码不一致",
      "email is required": "请填写邮箱",
      "email is not correct": "邮箱格式不正确",
      "protocol is required": "请先同意注册协议"
    },
    "agreement": {
      "s1": "我同意",
      "s2": "用户注册许可协议"
    },
    "registerBtn": "注 册",
    "loading": "正在注册",
    "authBtn": "获取验证码"
  },
  /*---------------------------   修改密码    --------------------------*/
  "changePsd": {
    "form": {
      "oldPsd": {
        "name": "旧密码",
        "placeholder": "请输入旧密码"
      },
      "newPsd": {
        "name": "新密码",
        "placeholder": "请输入新密码"
      },
      "confirmPsd": {
        "name": "新密码",
        "placeholder": "请再次输入新密码"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "请输入验证码"
      },
    },
    "rulesErr": {
      "oldPsd is required": "请输入原密码",
      "newPsd is required": "请输入新密码",
      "confirmPsd is required": "请再次输入新密码",
      "authCode is required": "请输入验证码",
      "psdNumber is not correct": "请填写6至20位密码",
      "inconsistent password": "两次输入的密码不一致",
    },
    "cancelBtn": "取消",
    "confirmBtn": "确定"
  },
  /*首页*/
  index: {
    navTitle: {
      title1: "公告事项",
      title2: "新闻中心",
      title3: "旅游信息"
    },
    consulting: "资讯",
    Notice: "公告事项",
    procedures: {
      procedures: "办签流程",
      'Add Applicants': "添加申请人",
      'Fill in the information': "填写资料",
      'Postal information entry': "填写寄送信息",
      'Confirm and pay': "确认并支付",
      'Waiting for the visa': "等待出签",
      'Visa application result': "自取或回寄出签结果"
    },
    visaCenter: '韩国签证申请中心',
    'Consulate information': "领事馆信息",
    'Convenient service': "便捷服务",
    service: {
      'division of jurisdictions': "领区划分",
      'Visa application form download': "签证申请表下载",
      'Common problems': "常见问题",
      'Other materials download': "其他资料下载",
    },
    link: "友情链接"
  },
  /*---------------------------   个人中心     --------------------------*/
  "center": {
    "userMsg": "消息中心",
    "orderList": "我的订单",
    "applyTodoList": "待办申请",
    "address": "常用地址",
    "invoiceTitle": "发票抬头",
    "feedback": "意见反馈",
    "logout": "退出登录",
    "changePhone": "更换手机",
    "changePsd": "修改密码",
    "setting": "设置",
    logoutNotice: "是否确认要退出登录？",
    'Working days': "工作日"
  },
  /*---------------------------   签证中心     --------------------------*/
  "visaCenter": {
    "Working hours and contact information": '工作时间及联系方式 ',
    "Visa fee description": '签证费用说明',
  },
  /*---------------------------   消息中心     --------------------------*/
  "userMsg": {
    "navTitle": {
      "title1": "系统消息",
      "title2": "公告消息"
    }
  },
  /*---------------------------   我的订单     --------------------------*/
  "orderList": {
    title: "我的订单",
    Name: "姓名",
    to: "至",
    'Passport no': "护照号",
    'jurisdictions': "领区",
    'Express service1': "寄送快递",
    'Id card number': "身份证号",
    'Application date': "申请日期",
    'Sub account': "子账号",
    'Express service2': "回寄快递",
    'Mobile phone no': "手机号",
    'Creation time': "创建时间",
    'The order number': "订单号",
    'Order Amount': "订单金额",
    'Send a single number': "寄送方式",
    'The name': "姓名",
    'To apply for the jurisdictions': "申请领区",
    'state': "状态",
    "navTitle": {
      "title1": "全部订单",
      "title2": "进行中",
      "title3": "已完成"
    },
    "orderItem": {},
    nav1: "首页",
    nav2: "个人中心",
    nav3: " 我的订单",
    screening: "筛选",
    empty: "清空",
    "view": "查看",
    "Expand": "展开",
    "Check the invoice": "查看发票",
    "To apply for the invoice": "申请发票",
    "To apply for the invoice1": "开票中",
    "To apply for the invoice2": "已开具",
    "Profile picture": "申请照片",
    "Name/pinyin": "姓名/拼音",
    "Passport number": "护照号",
    "Gender": " 性别",
    "Application type": "申请类型",
    "Domicile place": "户籍所在地",
    "Reply mode": "回寄方式",
    "Application status": "申请状态",
    'operation': "操作",

    "Start date": "开始日期",
    "end date": "结束日期"
  },
  /*---------------------------   订单详情     --------------------------*/
  "orderDetail": {
    "The recipient": "收件人", "Mobile phone number": "手机号", "address": "地址",
    "use one mailing address1": "以下",
    "use one mailing address2": "人，使用一个寄送地址",
    title: "订单详情",
    nav1: "首页",
    nav2: "个人中心",
    nav3: "我的订单",
    "The order number": "订单编号",
    "Creation time": "创建时间",
    "Check the application form": "查看申请表",
    "Delivery charge": "寄送快递费用",
    "Delivery check": "查看快递进度",
    "return express fee": "回寄快递费用",
    "Click to view the required materials": "点击查看所需材料",
    "Send the required materials to the e-mail": "将所需材料发送到邮箱",
    "The payment information": "支付信息",
    "Payment amount": "支付总金额",
    "payment": "去支付",
    "payment method": "支付方式",
    "Payment time": "支付时间",


    "Visa fee（consulate charges）": "签证费用（驻中韩国公馆收取）",
    "Visa service charge（Visa center charges）": "签证服务费（签证中心收取）",
    "The urgent charge": " 加急费用（驻中韩国公馆收取）",

    "navTitle": {
      "title1": "签证详情",
      "title2": "快递详情"
    },
  },
  /*---------------------------   待办申请列表     --------------------------*/
  "applyTodoList": {
    title: "代办申请",
    "Waiting list": "待提交申请列表",
    "attention": "注意：只有相同的申请领区才能合并下单",
    "maximum": "合并下单申请人，共同使用送件方式（一次最多可申请5人）",
    "Please select an applicant": "请选择申请人",
    'Visa procedures': "办签流程",
    'Add Applicants': "添加申请人",
    'Fill in the information': "填写资料",
    'Fill in the mailing information': "填写寄送信息",
    'Confirm and pay': "确认并支付",
    'Waiting for the visa': "等待出签",
    'Pick up or send visa results': "自取或回寄出签结果",
    "s1": "办签流程",
    confirmBtn: "确认并下单",
    "Add applicant": "添加申请人",
  },
  /*---------------------------   消息列表     --------------------------*/
  msgList: {
    'Message center': "消息中心",
    'System message': "系统消息",
    'Notice': "公告消息",
  },
  /*---------------------------   地址列表     --------------------------*/
  addressList: {
    title: "常用地址",
    'Add new address': "添加新地址",
    'The recipient': "收件人",
    'region': "所在地区",
    'Detailed address': "详细地址",
    'Mobile phone number': "手机号码",
    'operation': "操作",
  },
  /*---------------------------   发票抬头     --------------------------*/
  invoiceList: {
    title: "发票抬头",
    'Add receipt name': "添加发票抬头",
    'type': "类型",
    'Contact phone number': "联系电话",
    'email': "接收邮箱",
    'Invoice name': "抬头",
    'other': "其他信息",
    'operation': "操作",
  },
  /*---------------------------   意见反馈     --------------------------*/
  feedback: {
    nav1: "首页",
    nav2: "个人中心",
    'title': "意见反馈",
    'Feedback information': "反馈信息",
    "Submit feedback": "提交反馈",
    "Over 6 words": "6字以上，200字以内",
  },
  /*---------------------------   签证申请类型页面     --------------------------*/
  choiceVisaType: {
    "WeChat customer service": '微信客服',
    "contact number": '联系电话',
    "Email consultation": '邮件咨询',
    "Official website": '官方网址',
    "Select visa center": '选择签证中心',
    "Select visa center tips": '选择签证中心后即可显示当前签证中心所受理的常住生活工作城市。（常住生活工作城市以在当地拥有社保或居住卡为准）',
    "Purpose of visit": '访问目的',
    "Type of visa": '签证种类',
    "Issued to": '签发对象',
    "Do you need help": '您需要帮助吗?',
    "View Example": '查看示例',
    "Download files": '下载文件',
    "On line printing and filling": '线上机打填写',
    "Description of Expenses": "费用说明",
    "Visa fee（consulate charges）": "签证费用（驻中韩国公馆收取）",
    "Visa service charge（Visa center charges）": "签证服务费（签证中心收取）",
    "The urgent charge": " 加急费用（驻中韩国公馆收取）",
    "Urgent or not": '是否加急',
    "attention": "注意",
    "urgent service1": "加急办理，需增收",
    "urgent service2": "元/人",
    "Visa Description": "签证说明",
    "The urgent is only based": "加急办理仅优先审核材料并提交至领馆，不承诺出签时间与出签成功率",
    "Application Form fill in type": "申请表填写方式",


    "Click to view the required materials": "点击查看所需材料",
    "Send the required materials to the e-mail": "将所需材料发送到邮箱",
    "Apply": "开始申请",
    title: "签证申请",
    "container": {
      "s1": "韩国签证申请中心",
    },
    confirmBtn: "开始办理",
    form: {
      letter: {
        s1: '本人已充分理解并确认',
        s2: '《个人信息保护告知书》',
        s3: '和',
        s4: '《个人信息处理同意书》',
        s5: '的全部内容，',
        s6: '同意提交申请签证所需的各种信息，以及各种证明材料的原件和复印件。',
      },
      mode: {
        name: '注意事项：',
        s1: '1. 申请人必须如实、完整、准确地填写申请表',
        s2: '2. 务必打印申请表，与材料一并提交',
        s3: '3. 签证审核过程中，如果总领事馆认为有必要，可能会要求申请人提交补充材料、或要求与申请人面谈',
        s4: '4. 身份证、户口本、结婚证等个人身份信息材料或照片原件等补助材料，接收（审核）后将会与护照一同返还，其他材料不予返还',
        s5: '5. 签证手续费在签证申请后不予退还',
      },
      location: {
        name: "选择常住生活/工作所在地",
        s1: "最终受理领区要以常住生活工作城市为准，即：在当地拥有社保或居住卡为准。",
        s2: "您的申请将提交到"
      },
      'Visa type': "签证类型",
      'Visa entries': "签证次数",
      'The urgent': "加急办理",
      'Required materials': "所需材料",

      type: {
        name: "选择签证类型"
      },
      period: {
        name: "选择有效期",
        s1: "入境次数：",
        s2: "停留天数：",
        s3: "有效期：",
        s4: "办理时长：",
      },
      expedited: {
        normal: "正常办理",
        expedited: "加急办理"
      },
      urgent: {
        name: "注意事项：",
        s1: "办理加急签证，需增收 ",
        s2: "元/人加急费用",
        s3: "加急签证审核时间为3个工作日",
        s4: "办理加急签证，将无法使用快递服务",
      },
      datum: {
        name: "所需资料",
        button: "所需资料发送到邮箱"
      }
    },
    rulesErr: {
      "locationValue is required": "请选择常住生活/工作所在地",
      "visaTypeValue is required": "请选择签证类型",
      "visaProductValue is required": "请选择有效期"
    }
  },
  aboutUs: {
    'HOME': "首页",
    'Site map': "网站地图",
    'About us': "关于我们",
    'Contact us': "联系我们",
    'Business cooperation': "商务合作",
  },
  savePassport: {
    "upload a passport photo": "上传护照",
    "View sample image": "查看样图",
    "If it is not China, please fill in manually": "如不是中国，请手动填写",
    container: {
      s1: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    },
    form: {
      passportNum: {
        name: "护照号码",
        placeholder: "",
      },
      surnameZh: {
        name: "姓名（中文）",
        placeholder: ""
      },
      nameZh: {
        name: "名（中文）",
        placeholder: ""
      },
      surnameEn: {
        name: "姓（英文）",
        placeholder: ""
      },
      nameEn: {
        name: "名（英文）",
        placeholder: ""
      },
      gender: {
        name: "性别",
        male: '男',
        female: '女'
      },
      birthDate: {
        name: "出生日期",
        placeholder: "选择日期"
      },
      birthPlaceZh: {
        name: "出生地点",
        placeholder: ""
      },
      birthPlaceEn: {
        name: "出生国家",
        placeholder: ""
      },
      issuancePlaceZh: {
        name: "签发地点",
        placeholder: ""
      },
      issuancePlaceEn: {
        name: "签发地点（英文）",
        placeholder: ""
      },
      issuanceDate: {
        name: "签发日期",
        placeholder: "选择日期"
      },
      issuancePeriod: {
        name: "有效期至",
        placeholder: "选择日期"
      },
    },
    "rulesErr": {
      'passportNum is required': "请填写护照号码",
      'requiredCount': "长度不能超过#num#字符", // Must not exceed 10 characters in length
      "surnameZh is required": "请填写姓名（中文）",
      "surnameEn is required": "请填写姓（英文）",
      "nameZh is required": "请填写名（中文）",
      "nameEn is required": "请填写名（英文）",
      "surnameEn is not correct": "姓（英文）不正确",
      "nameEn is not correct": "名（英文）不正确",
      "birthPlaceZh is required": "请填写出生地点",
      "passportSex is required": "请选择性别",
      "birthPlaceEn is required": "请填写出生国家",
      "issuancePlaceZh is required": "请填写签发地点",
      "issuancePlaceEn is required": "请填写签发地点（英文）",
      "birthDate is required": "请选择出生日期",
      "issuanceDate is required": "请选择签发日期",
      "issuancePeriod is required": "请选择到期时间",
      "date is not correct": "结束时间不能早于开始时间"
    },
    reUploadBtn: "重新上传",
    save2next: "保存，并下一步"
  },
  uploadIdCardFront: {
    "Upload id card": "上传身份证",
    "attention": "注意：身份证照片不清晰时系统无法识别内容、请重新核对。未成年儿童未办理身份证时、请上传出生医学证明。",
    "Upload id card front": "上传身份证正面",
    desc: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    form: {
      name: {
        title: "姓名",
        placeholder: "请输入姓名"
      },
      gender: {
        title: "性别",
        value1: "男",
        value2: "女",
      },
      nation: {
        title: "民族",
        placeholder: "请填写民族"
      },
      birthDay: {
        title: "出生日期",
        placeholder: "选择日期"
      },
      address: {
        title: "住址",
        placeholder: "请填写住址"
      },
      idCardNo: {
        title: "身份证号码",
        placeholder: "请填写身份证号码"
      },
      reUploadBtn: "重新上传",
      save2nextBtn: "下一步"
    },
    rulesErr: {
      "name is required": "请填写姓名",
      'idcardNumber': "请输入正确身份证号码",
      "gender is required": "请选择性别",
      "nation is required": "请填写民族",
      "birthDate is required": "请选择出生日期",
      "address is required": "请填写住址",
      "idCardNo is required": "请填写身份证号码",
    }
  },
  uploadIdCardBack: {
    "Minorchild, did not handle id card": "未成年人，未办理身份证",
    desc: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    "Upload id card back": "上传身份证背面",
    "Minor child, did not handle id card": "未成年儿童，未办理身份证",
    "attention": "提醒：未成年儿童，未办理身份证时，邮寄材料里需要提供出生医学证明原件和复印件，并上传原件照片。",
    "Upload medical certificate of birth": "上传出生医学证明",
    form: {
      datePlaceholder: "选择日期",
      idcardAuthority: {
        title: "签发机构",
        placeholder: "请填写签发机构"
      },
      cardNumber: {
        title: "身份证号码",
        placeholder: "请填写身份证号"
      },
      idcardDate: "有效期",
      idcardForever: "长期身份证",
      longEffective: "长期有效"
    },
    rulesErr: {
      "idcardAuthority is required": "请填写签发机构",
      "idcardStartDate is required": "请选择开始时间",
      "idcardEndDate is required": "请选择结束时间",
      "date is not correct": "结束日期不能早于开始日期",
    }
  },
  uploadAvatar: {
    "Upload ID picture": "上传电子照片",
    "attestation photo manual": "电子照片说明:",
    "desc1": "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
    "desc2": "2、邮寄申请资料里必须和电子照片一致。",
    "desc3": "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
    "desc4": "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
    "desc5": "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    "Check it and go to the next page": "准确无误，下一步"
  },
  // ------------------  银行卡 start -----------------------
  bankCard: {
    "Upload UnionPay card": "上传银联白金/砖石信用卡",
    "UnionPay card ID": "银联卡号",
    "UnionPay card ID placeholder": "请填写银联卡号",
    "UnionPay card ID number roles": "请输入正确的银联卡号",
    "UnionPay card Grade": "卡等级",
    "UnionPay card Grade roles": "请选择卡等级",
    "select placeholder": "请选择",
    "Issuing bank": "发卡行",
    "Issuing bank roles": "请选择发卡行",
    "card type": "卡类型",
    "Reserved mobile phone number": "预留手机号",
    "Reserved mobile phone number placeholder": "请输入预留手机号",
    "Reserved mobile phone number roles": "请输入正确手机号",
    "toDetail": "查看样图",
    "Update UnionPay Card Url": "上传银行卡",
    "prompt": "*注意",
    "desc1": "1、需上传含有",
    "desc2": "银联卡号一面",
    "desc3": "的照片",
    "desc4": "2、若银联卡号在背面，为保护您的信用卡安全，请您务必",
    "desc5": "遮挡信用卡背面后3位CVV码",
    "desc6": "后拍照上传"
  },
  // ------------------  银行卡 end -----------------------
  savePersonalInfo: {
    title: "个人信息",
    attention: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    "question1": "*是否曾用别名入境韩国或从韩国出境？",
    "surnameZh": "别名（姓）",
    "nameZh": "别名（名）",
    "question2": "*是否拥有双重国籍？",
    "orderNationality": "*其它国家国籍",
    "surnameZhPlaceholder": "请填写姓",
    "nameZhPlaceholder": "请填写名",
    "orderNationalityPlaceholder": "请输入国家名称",
    "question3": "*是否持有其它护照？",
    "question4": "*其它护照类型",
    "passportType": {
      "type1": "外交护照",
      "type2": "公务护照",
      "type3": "普通护照",
      "type4": "其它"
    },
    "passportNum": {
      name: "*护照号码",
      placeholder: "请输入护照号码"
    },
    "issuancePlace": {
      name: "*签发国家",
      placeholder: "请输入签发国家"
    },
    issuancePeriod: {
      name: "*有效期至",
      placeholder: "请输入有效期"
    },
    "issuanceOrg": {
      name: "*签发机关",
      placeholder: "请输入签发机关"
    },
    rulesErr: {
      "usedOtherName is required": "请选择是否曾用名",
      "holdOtherCountry is required": "请选择是否拥有双重国籍",
      "holdOtherPassport is required": "请选择是否拥有其他护照",
      "surnameZh is required": "请填写姓（中文）",
      "nameZh is required": "请填写名（中文）",
      "orderNationality is required": "请输入国家名称",
      "passportNum is required": "请输入护照号码",
      "issuancePlace is required": "请输入签发国家",
      "issuancePeriod is required": "请选择到期时间",
      "issuanceOrg is required": "请输入签发机关",
      "otherPassportType is required": "请选择护照类型",
    },
    "yes": "是",
    "no": "否",
    "save2nextBtn": "保存，并下一步"
  },
  SaveContactInfo: {
    title: "联系信息",
    description: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    address: "*本国地址",
    addressPlaceholder: "请输入本国地址详细地址",
    nowAddress: "现居住地址",
    desc: "现居住地址如果与本国地址不同则需要填写",
    nowAddressPlaceholder: "请输入现居住地址",
    mobile: "*手机",
    mobilePlaceholder: "请输入手机号码",
    telephone: "*电话",
    telephonePlaceholder: "请输入电话号码",
    email: "*邮箱",
    emailPlaceholder: "请输入邮箱",
    "Emergency contact information": "紧急联系人信息",
    "The surname": "姓（英文）",
    "Name": "名（英文）",
    "Please enter the last name of the emergency contact": "请输入紧急联系人姓",
    "Please enter the name of the emergency": "请输入紧急联系人名",
    emergencyContact: "*紧急联系人",
    contactName: "*姓名",
    contactNamePlaceholder: "请输入紧急联系人姓名",
    contactMobile: "*电话",
    contactMobilePlaceholder: "请输入紧急联系人电话",
    contactNationValuePlaceholder: "请输入紧急联系人居住国家",
    emergencyRelationshipPlaceholder: "请输入与紧急联系人关系",
    contactNation: "*居住国家",
    contactRelation: "*与申请人关系",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "address is required": "请输入本国地址",
      "nowAddress is required": "请输入现居住地址",
      "mobile is required": "请输入手机号码",
      "telephone is required": "请输入电话号码",
      "email is required": "请输入邮箱",
      "contactName is required": "请输入紧急联系人姓名",
      "contactMobile is required": "请输入紧急联系人电话",
      "contactNationValue is required": "请输入居住国家",
      "contactRelationValue is required": "请输入与联系人关系",
    }
  },
  saveMemberInfo: {
    title: "家庭成员信息",
    maritalStatus: {
      title: "*婚姻状况",
      status1: "已婚",
      status2: "离婚",
      status3: "单身",
    },
    spouseInfo: {
      title: "*配偶信息",
      surnameZh: "姓（英文）",
      surnameZhPlaceholder: "请输入配偶姓",
      nameZh: "名（英文）",
      nameZhPlaceholder: "请输入配偶名",
      birthDate: "*出生日期",
      birthDatePlaceholder: "请选择出生日期",
      nationality: "*国籍",
      nationalityPlaceholder: "请输入国籍",
      mobile: "*联系电话",
      mobilePlaceholder: "请输入配偶电话",
      address: "*居住地址",
      addressPlaceholder: "请输入居住地址"
    },
    haveChild: {
      question: "*是否有子女?",
      yes: "是",
      no: "否",
      childrenCount: {
        title: "子女人数",
        placeholder: "请输入子女人数",
      }
    },
    rulesErr: {
      "surnameZh is required": "请输入配偶姓",
      "marital is required": "请选择婚姻状况",
      "nameZh is required": "请输入配偶名",
      "birthDate is required": "请选择出生日期",
      "contactNationValue is required": "请输入国籍",
      "mobile is required": "请输入配偶电话",
      "address is required": "请输入居住地址",
      "childrenCount is required": "请输入子女人数",
      "haveChild is required": "请选择是否有子女",
    },
    save2nextBtn: "保存，并下一步"
  },
  saveEducationInfo: {
    title: "教育信息",
    "Professional information": "职业信息",
    educationBg: {
      title: "*最高学历",
      value1: "硕士/博士",
      value2: "学士",
      value3: "高中",
      value4: "其它",
    },
    otherEducationBg: "*其它学历，请说明",
    educationDescriptionPlaceholder: "请输入其他学历说明",
    universityNamePlaceholder: "请输入学校名称",
    universityPlacePlaceholder: "请输入学校所在地",
    schoolName: "*学校名称",
    schoolLocation: "*学校所在地",
    profession: {
      title: "*当前职业",
      value1: "企业家",
      value2: "自雇",
      value3: "公司职员",
      value4: "公务员",
      value5: "学生",
      value6: "退休",
      value7: "无业",
      value8: "其它",
    },
    occupationDescription: "*其他职业说明",
    occupationDescriptionPlaceholder: "请输入其他职业说明",
    organizationName: "*公司/机关/学校名称",
    organizationNamePlaceholder: "请输入公司/机关/学校名称",
    organizationPosition: "*职业/课程",
    organizationPositionPlaceholder: "请输入职业/课程",
    organizationAddress: "*公司/机关/学校地址",
    organizationAddressPlaceholder: "请输入公司/机关/学校地址",
    organizationPhone: "*公司/机关/学校联系电话",
    organizationPhonePlaceholder: "请输入公司/机关/学校联系电话",
    otherProfession: "*其它职业，请说明",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "education is required": "请选择学历",
      "occupation is required": "请选择职业",
      "educationDescription is required": "请输入其他学历说明",
      "universityName is required": "请输入学校名称",
      "universityPlace is required": "请输入学校所在地",
      "occupationDescription is required": "请输入其他职业说明",
      "organizationName is required": "请输入公司/机关/学校名称",
      "organizationPosition is required": "请输入职业/课程",
      "organizationAddress is required": "请输入公司/机关/学校地址",
      "organizationPhone is required": "请输入公司/机关/学校联系电话",
    },

  },
  saveAccessInfo: {
    title: "访问信息",
    Application: {
      title: "*申请入境事由",
      value1: "旅游/过境",
      value2: "参加会议等活动",
      value3: "医疗旅游",
      value4: "短期商务",
      value5: "学习/培训",
      value6: "就业活动",
      value7: "贸易/投资/派驻",
      value8: "探亲访友",
      value9: "结婚移民",
      value10: "外交/公务",
      value11: "其他",
      other: "其他入境事由",
      otherPlaceholder: "请输入其他入境事由"
    },
    access: {
      "days of detention": {
        title: "*拟滞留天数",
        value1: "90天(含)以下",
        value2: "91天(含)以上",
        value3: "永久",
      },
      "Date of departure": "出国日期",
      date: "*拟入境日期",
      datePlaceholder: "拟入境日期",
      days: "*拟滞留天数",
      mobile: "*在韩联系电话",
      address: "*在韩滞留地址/酒店"
    },
    families: {
      question: "*是否有同行家属？",
      yes: "是",
      no: "否",
      family: {
        surname: "姓（英文）",
        Name: "名（英文）",
        birth: "出生日期",
        nationality: "国籍",
        Relationship: "与申请人关系",
      },
      error: {
        surname: "请输入英文姓",
        surnameErr: "请输入正确的英文姓",
        Name: "请输入英文名",
        NameErr: "请输入正确的英文名",
        birth: "出生日期",
        nationality: "国籍",
        Relationship: "与申请人关系",
      },
      "Add fellow pedestrians": "添加同行人"
    },
    records: {
      question1: "*近五年内是否访问过韩国？",
      "Purpose of recent visit": "近期访问目的",
      "Visit purpose": "访问目的",
      "During the visit": "访问期间",
      count: "*五年内访韩次数",
      purpose: "*近期入境目的",
      question2: "*近五年内是否访问过除韩国外其它国家？",
      countries: {
        title: "其它访问国家",
        name: "*国家名称（英文）",
        purpose: "*访问目的",
        period: "访问期间"
      },
      dateStartPlaceholder: "开始时间",
      dateEndPlaceholder: "截止时间",
      yes: "是",
      no: "否",
      "Add Access Log": "增加访问记录",
      "Add Visiting Country": "增加访问国家",
    },
    haveInKorea: {
      question: "*是否有家属在韩居住？",
      family: {
        title: "在韩家属",
        familyName: "*姓名（英文）",
        familyBirthDate: "*出生日期",
        familyCountry: "*国籍",
        familyRelationship: "*与申请人关系"
      },
      yes: "是",
      no: "否",
      nameErr: "请输入正确的英文姓名",
      "Add family members living in Korea": "添加在韩家属",
      relationship: {
        value1: "配偶",
        value2: "子女",
        value3: "父母",
        value4: "兄弟姐妹",
      }
    },
    rulesErr: {
      "date is required": "请选择拟入境日期",
      "phone is required": "只允许填写数字0-9",
      "days is required": "请填写拟滞留天数",
      "mobile is required": "请填写在韩联系电话",
      "address is required": "请填写在韩滞留地址",
      "name is required": "请填写同行家属姓名",
      "birthDate is required": "请选择同行家属生日",
      "country is required": "请填写同行家属国籍",
      "relationship is required": "请选择与同行家属关系",
      "visitedValue is required": "请选择近五年是否访问过韩国",
      "visitedPurposeValue is required": "请输入近期访问目的",
      "visitedTimes is required": "请输入近期访问次数",
      "hadVisitedOther is required": "请选择是否访问过除韩国外的其他国家",
      "countryName is required": "请选择国家",
      "visitedPurpose is required": "请输入访问目的",
      "visitedCountry is required": "请输入访问国家",
      "dateStart is required": "请选择开始日期",
      "dateEnd is required": "请选择截止日期",
      "haveFamily is required": "请选择是否有同行家属",
      "haveInKorea is required": "请选择是否有家属在韩居住",
      "familyName is required": "请输入在韩家属姓名",
      "familyBirthDate is required": "请选择在韩家属出生日期",
      "familyCountry is required": "请输入在韩家属国籍",
      "familyRelationship is required": "请选择在韩家属与申请人关系",
      "date is not correct": "结束日期不能早于开始日期",
      "Please enter other Immigration Arrangements": "请输入其他入境事由",
      "Please select a date to go abroad": "请选择出国日期",
      "Please enter your purpose of recent visit": "请输入近期入境目的"
    },
    save2nextBtn: "保存，并下一步"
  },
  saveOtherInfo: {

    invitation: {
      title: "在韩邀请方信息",
      question: "*是否在韩国有邀请人或邀请单位？",
      yes: "是",
      no: "否",
      name: "*邀请人姓名或邀请单位名",
      info: "*邀请人出生日期或邀请单位登记证号码",
      contactRelation: "*与申请人关系",
      invitedAddress: "*邀请人或邀请单位地址",
      mobile: "*联系电话",
      invitedRelationship: "*邀请人与申请人的关系"
    },
    cost: {
      title: "费用信息",
      question: "*谁将承担在韩国期间的费用",
      value1: "自己",
      value2: "邀请方",
      value3: "他人支付",
      paymentType: "*支付类型",
      cost: "*在韩期间费用（以美元为准）",
      payerName: "*姓名/单位（或团队）名称",
      payerRelationship: "*费用承担者与申请人关系",
      "phone number": "*联系电话"
    },
    assist: {
      title: "协助填表人信息",
      question: "*是否有人协助填写本申请",
      yes: "是",
      no: "否",
      name: "*姓名",
      birthDate: "*出生日期",
      mobile: "*电话",
      contactRelation: "*与申请人关系",
      birthDatePlaceholder: "出生日期"
    },
    rulesErr: {
      "haveInvited is required": "请选择是否在韩国有邀请人或邀请单位",
      "invitedName is required": "请填写邀请人姓名或邀请单位名",
      "invitedInfo is required": "请填写邀请人出生日期或邀请单位登记证号码",
      "invitedAddress is required": "请填写邀请人或邀请单位地址",
      "invitedContact is required": "请填写邀请人联系电话",
      "invitedRelationship is required": "请填写邀请人与申请人的关系",
      "payType is required": "请填写支付类型",
      "cost is required": "请填写在韩期间费用",
      "payerName is required": "请填写姓名/单位（或团队）名称",
      "costPayer is required": "请选择谁将承担在韩期间的费用",
      "payerRelationship is required": "请填写费用承担者与申请人关系",
      "haveHelper is required": "请选择是否有协助人",
      "helperName is required": "请填写协助人姓名",
      "helperBirthDate is required": "请选择协助人的出生日期",
      "helperContact is required": "请填写协助人的联系方式",
      "helperRelationship is required": "请填写与申请人的关系",
      "Please enter the phone number": "请输入联系电话",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*---------------------------   申请人资料     --------------------------*/
  /*上传护照首页*/
  visaForm1: {
    title: "护照首页模板",
    container: {
      s1: "1、护照离出发日必须有6个月以上有效期",
      s2: "2、拍摄上传彩色的护照首页，字体清晰可见"
    },
    button: "点击开始拍照"
  },
  "visaForm1-1": {
    container: {
      s1: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    },
    form: {
      passportNum: {
        name: "护照号码",
        placeholder: "",
      },
      surnameZh: {
        name: "姓（中文）",
        placeholder: ""
      },
      nameZh: {
        name: "名（中文）",
        placeholder: ""
      },
      surnameEn: {
        name: "姓（英文）",
        placeholder: ""
      },
      nameEn: {
        name: "名（英文）",
        placeholder: ""
      },
      gender: {
        name: "性别",
        male: '男',
        female: '女'
      },
      birthDate: {
        name: "出生日期",
        placeholder: ""
      },
      birthPlaceZh: {
        name: "出生地点（中文）",
        placeholder: ""
      },
      birthPlaceEn: {
        name: "出生地点（英文）",
        placeholder: ""
      },
      issuancePlaceZh: {
        name: "签发地点（中文）",
        placeholder: ""
      },
      issuancePlaceEn: {
        name: "签发地点（英文）",
        placeholder: ""
      },
      issuanceDate: {
        name: "签发日期",
        placeholder: ""
      },
      issuancePeriod: {
        name: "有效期至",
        placeholder: ""
      },
    },
    "rulesErr": {
      'passportNum is required': "请填写护照号码",
      "surnameZh is required": "请填写姓（中文）",
      "surnameEn is required": "请填写姓（英文）",
      "nameZh is required": "请填写名（中文）",
      "nameEn is required": "请填写姓（英文）",
      "birthPlaceZh is required": "出生地点（中文）",
      "birthPlaceEn is required": "出生地点（英文）",
      "issuancePlaceZh is required": "请填写签发地点（中文）",
      "issuancePlaceEn is required": "请填写签发地点（英文）",
    },
    reUploadBtn: "重新上传",
    save2next: "保存，并下一步"
  },
  /*上传身份证*/
  "visaForm2": {
    IDCard: {
      s1: "身份证人像面",
      s2: "身份证国徽面",
      s3: "点击开始拍照",
      instructions: {
        s1: "1、清晰拍摄正反面、不能反光",
        s2: "2、请注意露出四个边角，不要压边拍摄",
        s3: "3、临时身份证不可申请签证",
      }
    },
    minor: {
      title: "未成年儿童，未办理身份证",
      instructions: "提醒 ：未成年儿童，未办理身份证时，邮寄材料里需要提供出生医学证明复印件，并上传原件照片。"
    },
    saveBtn: "保存，并下一步"
  },
  /*上传电子照片*/
  "visaForm3": {
    title: "上传电子照片",
    instructions: {
      s1: "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
      s2: "2. 邮寄申请资料里必须和电子照片一致。",
      s3: "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;",
      s4: "嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
      s5: "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
      s6: "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    },
    takePhotoBtn: "点击开始拍照",
    uploadPhotoBtn: "我已有签证照，直接上传"
  },
  "visaForm3-1": {
    title: "上传电子照片",
    uploadSu: "电子照片已上传",
    instructions: {
      s1: "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
      s2: "2. 邮寄申请资料里必须和电子照片一致。",
      s3: "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;",
      s4: "嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
      s5: "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
      s6: "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    },
    reUploadBtn: "重新上传",
    save2nextBtn: "保存，并下一步"
  },
  /*个人信息*/
  "visaForm4": {
    "question1": "*是否曾用别名入境韩国或从韩国出境？",
    "surnameZh": "姓（中文）",
    "nameZh": "名（中文）",
    "question2": "*是否拥有双重国籍？",
    "orderNationality": "*其它国家国籍",
    "orderNationalityPlaceholder": "请输入国家名称",
    "question3": "*是否持有其它护照？",
    "question4": "*其它护照类型",
    "passportType": {
      "type1": "外交护照",
      "type2": "公务护照",
      "type3": "普通护照",
      "type4": "其它"
    },
    "passportNum": {
      name: "*护照号码",
      placeholder: "请输入护照号码"
    },
    "issuancePlace": {
      name: "*签发地点",
      placeholder: "请输入签发地点"
    },
    issuancePeriod: {
      name: "*有效期至",
      placeholder: "请输入有效期"
    },
    "issuanceOrg": {
      name: "*签发机关",
      placeholder: "请输入签发机关"
    },
    rulesErr: {
      "surnameZh is required": "请填写姓（中文）",
      "nameZh is required": "请填写名（中文）",
      "orderNationality is required": "请输入国家名称",
      "passportNum is required": "请输入护照号码",
      "issuancePlace is required": "请输入签发地点",
      "issuancePeriod is required": "请输入有效期",
      "issuanceOrg is required": "请输入签发机关",
    },
    "yes": "是",
    "no": "否",
    "save2nextBtn": "保存，并下一步"
  },
  /*联系人信息*/
  "visaForm5": {
    description: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    address: "*本国住址",
    addressPlaceholder: "请输入本国地址",
    nowAddress: "*现居住地址",
    nowAddressPlaceholder: "请输入现居住地址",
    mobile: "*手机",
    mobilePlaceholder: "请输入手机号码",
    telephone: "*电话",
    telephonePlaceholder: "请输入电话号码",
    email: "*邮箱",
    emailPlaceholder: "请输入邮箱",
    emergencyContact: "*紧急联系人",
    contactName: "*姓名",
    contactNamePlaceholder: "请输入紧急联系人姓名",
    contactMobile: "*电话",
    contactMobilePlaceholder: "请输入紧急联系人电话",
    contactNation: "*居住国家",
    contactRelation: "*与申请人关系",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "address is required": "请输入本国地址",
      "nowAddress is required": "请输入现居住地址",
      "mobile is required": "请输入手机号码",
      "telephone is required": "请输入电话号码",
      "email is required": "请输入邮箱",
      "contactName is required": "请输入紧急联系人姓名",
      "contactMobile is required": "请输入紧急联系人电话",
      "contactNationValue is required": "请选择居住国家",
      "contactRelationValue is required": "请选择与联系人关系",
    }
  },
  /*家庭成员信息*/
  "visaForm6": {
    maritalStatus: {
      title: "*婚姻状况",
      status1: "已婚",
      status2: "未婚",
      status3: "单身",
    },
    spouseInfo: {
      title: "*配偶信息",
      surnameZh: "姓（中文）",
      surnameZhPlaceholder: "请输入配偶姓",
      nameZh: "名（中文）",
      nameZhPlaceholder: "请输入配偶名",
      birthDate: "*出生日期",
      birthDatePlaceholder: "请选择出生日期",
      nationality: "*国籍",
      mobile: "*电话",
      mobilePlaceholder: "请输入配偶电话",
      address: "*居住地址",
      addressPlaceholder: "请输入居住地址"
    },
    rulesErr: {
      "surnameZh is required": "请输入配偶姓",
      "nameZh is required": "请输入配偶名",
      "birthDate is required": "请选择出生日期",
      "contactNationValue is required": "请选择国籍",
      "mobile is required": "请输入配偶电话",
      "address is required": "请输入居住地址",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*教育信息*/
  "visaForm7": {
    educationBg: {
      title: "*最高学历",
      value1: "硕士/博士",
      value2: "学士",
      value3: "高中",
      value4: "其它",
    },
    otherEducationBg: "*其它学历，请说明",
    schoolName: "*学校名称",
    schoolLocation: "*学校所在地",
    profession: {
      title: "*当前职业",
      value1: "事业家",
      value2: "自雇",
      value3: "公司职员",
      value4: "公务员",
      value5: "学生",
      value6: "无业",
      value7: "退休",
      value8: "其它",
    },
    rulesErr: {
      "otherEducationBg is required": "请输入其他学历说明",
      "schoolName is required": "请输入学校名称",
      "schoolLocation is required": "请输入学校所在地",
      "occupationDescription is required": "请输入其他职业说明",
    },
    occupationDescription: "其他职业说明",
    otherProfession: "*其它职业，请说明",
    save2nextBtn: "保存，并下一步"
  },
  /*访问信息*/
  "visaForm8": {
    access: {
      date: "*拟入境日期",
      datePlaceholder: "拟入境日期",
      days: "*拟滞留天数",
      mobile: "*在韩联系电话",
      address: "*在韩滞留地址/酒店"
    },
    families: {
      question: "*是否有同行家属？",
      yes: "是",
      no: "否",
      family: {
        title: "*同行家属",
        name: "*姓名",
        birthDate: "*出生日期",
        nationality: "*国籍",
        contactRelation: "*与申请人关系"
      }
    },
    records: {
      question1: "*近五年内是否访问过韩国？",
      count: "*五年内访韩次数",
      purpose: "*近期入境目的",
      question2: "*近五年内是否访问过除韩国外其它国家？",
      countries: {
        title: "其它访问国家",
        name: "*国家名称",
        purpose: "*访问目的",
        period: "有效期"
      },
      dateStartPlaceholder: "开始时间",
      dateEndPlaceholder: "截止时间",
      yes: "是",
      no: "否",
    },
    rulesErr: {
      "date is required": "请选择拟入境日期",
      "days is required": "请填写拟滞留天数",
      "mobile is required": "请填写在韩联系电话",
      "address is required": "请填写在韩滞留地址",
      "name is required": "请填写同行家属姓名",
      "birthDate is required": "请选择同行家属生日",
      "country is required": "请选择同行家属国籍",
      "relationship is required": "请选择与同行家属关系",
      "visitedValue is required": "请选择近期访问次数",
      "visitedPurposeValue is required": "请选择近期访问目的",
      "countryName is required": "请选择国家",
      "visitedPurpose is required": "请选择访问目的",
      "dateStart is required": "请选择开始日期",
      "dateEnd is required": "请选择截止日期",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*其他信息*/
  visaForm9: {
    invitation: {
      question: "*是否在韩国有邀请人或邀请单位？",
      yes: "是",
      no: "否",
      name: "*邀请人姓名或邀请单位名",
      info: "*邀请人出生日期或邀请单位登记证号码",
      contactRelation: "*与申请人关系",
      invitedAddress: "*邀请人或邀请单位地址",
      mobile: "*联系电话"
    },
    cost: {
      question: "*谁将承担在韩国期间的费用",
      value1: "自己",
      value2: "邀请方",
      value3: "他人支付",
      paymentType: "*支付类型",
      cost: "*在韩期间费用（以美元为准）",
      payerName: "*姓名/单位（或团队）名称",
      payerRelationship: "*费用承担者与申请人关系"
    },
    assist: {
      question: "*是否有人协助填写本申请",
      yes: "是",
      no: "否",
      name: "*姓名",
      birthDate: "*出生日期",
      mobile: "*电话",
      contactRelation: "*与申请人关系",
      birthDatePlaceholder: "出生日期"
    },
    rulesErr: {
      "invitedName is required": "请填写邀请人姓名或邀请单位名",
      "invitedInfo is required": "请填写邀请人出生日期或邀请单位登记证号码",
      "invitedAddress is required": "请填写邀请人或邀请单位地址",
      "invitedContact is required": "请填写邀请人联系电话",
      "payType is required": "请填写支付类型",
      "cost is required": "请填写在韩期间费用",
      "payerName is required": "请填写姓名/单位（或团队）名称",
      "payerRelationship is required": "请选择费用承担者与申请人关系",
      "helperName is required": "请填写协助人姓名",
      "helperBirthDate is required": "请选择协助人的出生日期",
      "helperContact is required": "请填写协助人的联系方式",
      "helperRelationship is required": "请选择与协助人的关系",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*其他材料*/
  visaForm10: {
    business: {
      title: "请上传公司营业执照",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "说明：",
        s2: "1. 营业执照务必清晰",
        s3: "2. 必须加盖公司公章",
        s4: "3. 仅支持png/jpg格式图片",
        s5: "4. 图片大小不得超过500kb",
      }
    },
    invitation: {
      title: "请上传韩方邀请函图片（含邀请事由和归国保证书等内容）",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "说明：",
        s2: "1. 邀请公函务必清晰",
        s3: "2. 必须加盖公司公章",
        s4: "3. 仅支持png/jpg格式图片",
        s5: "4. 图片大小不得超过500kb",
      }
    },
    registered: {
      title: "",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "",
        s2: "",
        s3: "",
        s4: "",
        s5: "",
      }
    },
    verification: {
      title: "",
      placeholder: "",
    },
    lawDesc: "",
    save2nextBtn: "保存，并下一步"
  },
  /*寄送方式*/
  sendWay: {
    "Confirm delivery and payment information": "确认快递与支付信息",
    "To apply for together": "合并下单申请人",

    "outgoing courier information": "寄送材料信息",
    desc: "请选择送件方式，如果不需要合并寄送，请移除申请人",
    "Use express delivery": "使用快递送材料",
    "To visit the center": "自己送材料到签证中心",
    "Sender name": "*发件人姓名",
    "Mobile phone number": "*手机号",
    "Select area": "*选择地区",
    "Detailed address": "*详细地址",
    "Commonly used address": "使用常用地址",


    "Appointment Information": "预约信息",
    "Number of general visa applications": "一般签证申请数量",
    "Number of urgent visa applications": "加急签证申请数量",
    "Name of sender": "送签人姓名",
    "phone number": "联系方式",
    "Relationship with applicant": "与申请人关系",
    "Estimated time of visit": "预约时间",
    "exit date": "出国日期",
    "Select Date": "选择日期",
    "Please select a date to make a reservation visit": "选择预约送材料日期",
    "Please select a time to make a reservation visit": "选择预约送材料时间",
    "Appointment reminders": "预约须知",
    "Please enter the sender name": "请输入送签人姓名",
    "Please enter your mobile phone number": "请输入手机号",
    "Please select a estimated time of visit": "选择预约时间",
    "Please select a date to go abroad": "请选择出国日期",
    "Check and go to next page": "确认无误，下一步",
    state: {
      Myself: "本人",
      "Family members": "直属亲戚"
    },

    way: {
      type1: "使用快递寄送材料",
      type2: "自己送材料到签证中心"
    },
    sendList: {
      name: "*发件人姓名",
      phone: "*手机号",
      area: "*选择地区",
      provinceId: "请选择省",
      cityId: "请选择市",
      districtId: "请选择区",
      address: "详细地址",
      addAddress: "自动添加到常用地址",
      selectAddress: "选择常用地址"
    },
    reserveTime: {
      selectDate1: "选择预约材料日期",
      selectDate2: "选择预约材料时间",
      reserveTimePlaceholder: "请选择预约日期",
    },
    notice: {
      title: "预约须知",
      s1: "※ 网上预约者请务必准备好申请资料，可大大减少您申请签证的等待时间，继而提高资料接收效率。",
      s2: "网上预约可预约2个工作日之后的日期（工作日基准）",
      s3: "例：今天是12月1日，可申请预约12月3日及以后的日期；",
      s4: " ①  网上预约开放时间为当月及后续两个月，",
      s5: "例：2016年1月时，系统开放可预约时间至3月，如此类推；",
      s6: "②  预约成功前来签证中心申请时，请携带预约确认单；",
      s7: "③  同一个户口本的直系亲属（2寸以内）可由网上预约申请者代理申请签证；",
      s8: "④  同一个预约号码的其他申请者（非直系亲属）一定要本人及网上预约申请者一起到签证申请中心方可办理签证；",
      s9: "⑤  网上预约者不可重复申请预约，重复的预约将会被取消；",
      s10: "* 签证申请时，若因资料不足或不符，签证中心可不予以接收，因此申请人请务必事先准备好所需资料",
    },
    btn: {
      btn1: "查看所需资料内容",
      btn2: "所需资料发送到邮箱"
    },
    rulesErr: {
      "name is required": "请填写发件人姓名",
      "phone is required": "请填写发件人手机号",
      "address is required": "请填写发件人详细地址",
      "sendType is required": "请选择寄送方式",
      "provinceId is required": "请选择省份",
      "cityId is required": "请选择城市",
      "districtId is required": "请选择市区",
      "sendListReserveTime is required": "请选择自送预约日期",
    }

  },
  receiveWay: {
    "working hours": "工作时间", "address": "地址", "phone number": "电话", "e-mail": "邮箱",
    "Confirm delivery and payment information": "确认快递与支付信息",
    "Return Delivery Information": "申请人回寄快递信息",
    "Choose express": "使用快递回寄签证",
    "Visit the center to receive documents": "签证中心自取",
    "returning address": "回寄地址",
    "The recipient": "*收件人",
    "Mobile phone number": "*手机号",
    "Please select district": "*请选择地区",
    "Detailed address": "*详细地址",
    "Commonly used address": "使用常用地址",
    "Add Return Address": "添加签证回寄地址",
    "Please select an application to return to your address now": "请选择申请人，出签后下列申请人的资料会一同寄回当前地址",
    "Confirm the payment": "确认下单，去支付",
    "Are you sure of payment": "是否确认下单",

    way: {
      title: "请选择取件方式",
      type1: "使用快递回寄地址",
      type2: "签证中心自取件"
    },
    receiveAddress: {
      title: "回寄地址",
      btn1: "编辑地址",
      btn2: "使用常用地址"
    },
    selectApply: {
      title: "请选择申请人",
      desc: "出签后下列申请人的资料会一同寄回当前地址"
    },
    addAddressBtn: "增加签证回寄地址",
    rulesErr: {
      "name is required": "请填写收件人姓名",
      "phone is required": "请填写收件人联系方式",
      "province is required": "请选择省份",
      "city is required": "请选择城市",
      "district is required": "请选择县区",
      "address is required": "请填写收件人详细地址",
    }
  },
  confirmPay: {
    "Confirm payment information": "确认支付信息",
    "Delivery charge": "寄送快递费用",
    "Delivery check": "查看快递进度",
    "return express fee": "回寄快递费用",
    "Payment amount": "需支付金额",
    "payment method": "选择支付方式",
    "alipay": "支付宝支付",
    "WeChat pay": "微信支付",
    "To check and pay": "确认，并支付"
  },
  newAddress: {
    name: {
      title: "联系人",
      placeholder: "请输入联系人姓名"
    },
    phone: {
      title: "手机号码",
      placeholder: "请输入手机号码"
    },
    address: {
      title: "选择地址",
      placeholder: "请选择地址"
    },
    completeAddress: {
      title: "详细地址",
      placeholder: "请输入详细地址"
    },
    rulesErr: {
      "name is required": "请填写联系人姓名",
      "phone is required": "请填写联系人手机号",
      "provinceid is required": "请选择省份",
      "cityId is required": "请选择城市",
      "districtid is required": "请选择市区",
      "completeAddress is required": "请填写详细地址",
    },
    confirmBtn: "确定"
  },
  saveBasicInfo: {
    "Visa application information": "签证申请信息",
    "Upload basic information": " 上传基本资料",
    "Submit application information": " 提交申请信息",
    "View and save application information": " 确认信息并保存申请信息",
    "Upload passport": " 上传护照",
    "attention": "注意：护照照片不清晰时系统无法识别内容、请重点核对。",
  },
  saveApplyInfo: {
    "Visa application information": "签证申请信息",
    "Upload basic information": " 上传基本资料",
    "Submit application information": " 提交申请信息",
    "View and save application information": " 确认信息并保存申请信息",
    "Check and go to the next page": "确认无误，下一步",

    "Please check if the personal information is correct": "请检查个人信息是否完整",
    "Please check if the Contact information is correct": "请检查联系信息是否完整",
    "Please check if the marital status and family member information is correct": "请检查婚姻状况及家庭成员信息是否完整",
    "Please check if the educational information is correct": "请检查教育信息是否完整",
    "Please check if the job information is correct": "请检查职业信息是否完整",
    "Please check if the visit information is correct": "请检查访问信息是否完整",
    "Please check if the invitation information is correct": "请检查邀请方信息是否完整",
    "Please check if the expense information is correct": "请检查费用信息是否完整",
    "Save success": "保存成功",
  },
  confirmApply: {
    /*签证信息*/
    "Visa application information": "签证申请信息",
    "Upload basic information": " 上传基本资料",
    "Submit application information": " 提交申请信息",
    "View and save application information": " 确认信息并保存申请信息",
    "attention": "注意：请仔细核对以下信息，提交后资料无法修改！",
    "Application information": "申请信息",
    "the place where you live and work": "常住生活工作所在地",
    "Your application will be submitted to": "您的申请将提交到",
    "Visa type": "签证类型",
    "Visa entries": "签证次数",
    "The urgent": "加急办理",
    "Modify": "修改",

    "Please check the exact data": "确认资料真实准确",
    "Please enter the applicant name": "请输入申请人姓名",
    "Confirm that the name is used for the signature of the application form": "确认使用该名字作为申请表签字内容",
    /*护照信息*/
    passport: {
      "Passport information": "护照信息",
      "Modify": " 修改",
      "Passport number": " 护照号码",
      "The surname（Chinese）": "姓（中文）",
      "Name（Chinese）": "姓名（中文）",
      "Family Name（English）": "姓（英文）",
      "Given Name（English）": "名（英文）",
      "gender": "性别",
      "Date of birth": "出生日期",
      "Place of birth": "出生地点",
      "Country of birth": "出生国家",
      "Date of Issue": "签发日期",
      "place of issue": "签发地点",
      "Validity Period": " 有效期至",
    },
    /*身份证信息*/
    idCard: {
      "ID information": "身份证信息",
      "Modify": "修改",
      "Name": " 姓名",
      "gender": "性别",
      "ethnic groups": "民族",
      "Date of birth": "出生日期",
      "address": "住址",
      "Id card number": "身份证号码",
      "issuing authority": "签发机关",
      "Validity Period": "有效期",
    },
    /*银行卡信息*/
    unionPay: {
      "unionPay Name": "上传银联白金/砖石信用卡",
      "Modify": "修改",
      "UnionPay card ID": "银联卡号",
      "UnionPay card Grade": "卡等级",
      "Issuing bank": "发卡行",
      "card type": "卡类型",
      "Reserved mobile phone number": "预留手机号"
    },
    /*个人信息*/
    personal: {
      "personal information": "个人信息",
      "Modify": "修改",
      "Have you entered or left Korea under any other name?": "是否曾用别名入境韩国或从韩国出境？",
      "YES": "是",
      "NO": "否",
      "Other Name (the surname)": "别名（姓氏）",
      "Other Name(name)": "别名（名字）",
      "Whether you have dual nationality": "是否有双重国籍",
      "Nationality of other countries": "其他国家国籍",
      "Do you have other passports?": "是否持有其他护照",
      "Other passport types": "其他护照类型",
      "Passport number": "护照号码",
      "issuing country": "签发国家",
      "Validity Period": "有效期至",
    },
    /*联系信息*/
    contact: {
      "Contact Information": "联系信息",
      "Modify": "修改",
      "Home address": "本国住址",
      "Current residential address": "现居住地址",
      "Mobile phone number": "手机",
      "e-mail": "电子邮箱",
      "Emergency contact information": "紧急情况联系人信息(禁止填写本人信息)",
      "Name": "姓名",
      "Country of residence": "居住国家",
      "phone number": "电话",
      "Relationship with the applicant": "与申请人关系",
    },
    /*家庭成员*/
    member: {
      "Marital status and family member information": "家庭成员信息",
      "Modify": "修改",
      "Marital status": "婚姻状况",
      "spouse information": "配偶信息",
      "Family Name": "姓",
      "Given Name": "名",
      "Date of birth": "出生日期",
      "Nationality": "国籍",
      "residential address": "居住地址",
      "phone number": "联系电话",
      "Have children or not": "是否有子女",
      "NO": "否",
      "YES": "是",
      "the number of children": "子女人数",
      state: {
        "married": "已婚",
        "divorce": "离婚",
        "single": "单身",
      }
    },
    /*教育信息*/
    educational: {
      "educational information": "教育信息",
      "Modify": "修改",
      "the highest academic qualifications": "最高学历",
      "School name": "学校名称",
      "School location": "学校所在地",
      "Other qualifications please specify": "其他学历说明",
      state: {
        "Master": "硕士/博士",
        "Bachelor": "学士",
        "High school": "高中",
        "other": "其他",
      }
    },
    /*职业信息*/
    professional: {
      "Professional information": "职业信息",
      "The current career": "当前职业",
      "Name of company/agency/school": "公司/机关/学校名称",
      "Occupation/course": "职位/课程",
      "Company/office/school address": "公司/机关/学校地址",
      "Company/office/school contact number": "公司/机关/学校联系电话",
      "Other job description": "其他职业说明",
      state: {
        "entrepreneurs": "企业家",
        "self-employment": "自雇",
        "Company employees": "公司职员",
        "Civil servants": "公务员",
        "students": "学生",
        "unemployed": "无业",
        "retired": "退休",
        "other": "其他",
      }
    },
    /*访问信息*/
    access: {
      "access information": "访问信息",
      "days of detention": "拟滞留天数",
      "Intended date of entry": "拟入境日期",
      "Date of departure": "出国日期",
      "Contact number in Korea": "在韩联系电话",
      "Address/hotel in Korea": "在韩滞留地址/酒店",
      "Application for entry": "申请入境事由",
      "Are there any family members with you?": "是否有同行家属",
      "NO": "否",
      "YES": "是",
      "name(pinyin)": "姓名（拼音）",
      "Date of birth": "出生日期",
      "nationality": "国籍",
      "Relationship with applicant": "与申请人关系",
      "Are there any family members living in Korea?": "是否有在韩家属",
      relationshipState: {
        "spouse": "配偶", "children": "子女", "parents": "父母", "Brothers and sisters": "兄弟姐妹",
      },
      Application: {
        title: "*申请入境事由",
        value1: "旅游/过境",
        value2: "参加会议等活动",
        value3: "医疗旅游",
        value4: "短期商务",
        value5: "学习/培训",
        value6: "就业活动",
        value7: "贸易/投资/派驻",
        value8: "探亲访友",
        value9: "结婚移民",
        value10: "外交/公务",
        value11: "其他",
        other: "其他入境事由"
      },
      "Have you visited the rok in the past five years?": "近五年内是否访问过韩国？",
      "Recent Entry Purpose": "近期入境目的",
      "Have you visited any other countries other than Korea in the last five years?": "近五年内是否访问过除韩国外其他国家",
      "Country name": "国家名称",
      "Visit purpose": "访问目的",
      "During the visit": "访问期间",
    },
    /*邀请方信息*/
    invitation: {
      "Invitation information": "在韩邀请方信息",
      "Modify": "修改",
      "Is there an invitation or an invitation unit in Korea?": "是否在韩国有邀请人或邀请单位",
      "NO": "否",
      "YES": "是",
      "Invitee name or invite unit name": "邀请人姓名或邀请单位名",
      "Date of invitation or registration number of invitee for flat-enterprise registration": "邀请人出生日期或单位事业者登记证号码",
      "Relationship with applicant": "与申请人关系",
      "Address of inviter or unit": "邀请人或邀请单位地址",
      "phone number": "联系电话",
    },
    /*费用信息*/
    cost: {
      "expense information": "费用信息",
      "Modify": "修改",
      "Expenses during the period in Korea (based on US dollars)": "在韩期间费用（以美元为准）",
      "Payment type": "支付类型",
      "Name/unit (or team) name": "姓名/单位（或团队）名称",
      "The relationship between the undertaker and the applicant": "费用承担者与申请人关系",
      "phone number": "联系电话",
    },
    /*协助*/
    Helper: {
      "Helper information": "协助填表人信息",
      "Modify": "修改",
      "Is there anyone who helped me fill out this application?": "是否有人协助填填写申请",
      "name": "姓名",
      "Date of birth": "出生日期",
      "phone number": "电话",
      "Relationship with applicant": "与申请人关系",
    },
    "Required materials": "所需材料",
    "Click to view the required materials": "点击查看所需材料",
    "Send required information to mailbox": "将所需资料发送到邮箱",
    confirmed: "本人声明，本人已确认表格内容真实，准确无误，并保证遵守（大韩民国出入国管理法）有关规定",
    confirmBtn: "确认信息",
    "View the application": "查看电子申请表",
    "Please sign the QR code on your phone": "扫码二维码，手机上进行签名",
    "Please sign the QR code with WeChat": "打开微信扫一扫，在手机上完成签名",
    cancelBtn: "取消",
    signed: "已签名"
  },
  /*---------------------------   公共     --------------------------*/
  "common":
  {
    /*toast*/
    "toastLoading":
      "正在加载...",
    "toastWait":
      "请稍后...",
    /*loading*/
    "loading":
      "加载中...",
    "finished":
      "没有更多数据了",
    "loadErr":
      "加载失败,点击重试",
    /*select*/
    "pleaseSelect":
      "请选择"
  }
}




// WEBPACK FOOTER //
// ./src/assets/languages/zh.js